<template>
  <div class="d-flex justify-center text-center my-6 mt-12">
    <div>
      <v-icon size="100px">mdi-package-variant</v-icon>

      <h1>No transactions, yet</h1>
      <p>Oops, you haven't made a transaction yet.</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
